module.exports = __webpack_public_path__ + "img/placeholder.aea21900.jpeg";